angular.module('qkr').controller('videoTutorialController', ($scope,  $uibModalInstance, $sce, videoTutorial) => {
	$scope.videoTutorial = videoTutorial;
	$scope.canPlayTypes = canPlayTypes();
	
	$scope.toTrustedSource = function(source) {
		return $sce.trustAsResourceUrl(source);
	};
	
	$scope.config = {
        width: 800,
        height: 500,
        autoHide: true,
        autoPlay: true,
        responsive: false,
        stretch: 'fit',
        theme: {
        	url: '../css/videogular/videogular.css'
        }
    };
	
	$scope.ok = function() {
		$uibModalInstance.close('ok');
	};
	
	function canPlayTypes() {
		const videoTester = document.createElement('video');
		let canPlayTypes = false;
		
		if (videoTester != null && typeof (videoTester) !== 'undefined') {
			for (let i = 0; i < videoTutorial.sources.length; i++) {
				const source = videoTutorial.sources[i];
				if (videoTester.canPlayType(source.mimeType) != '') {
					canPlayTypes = true;
					break;
				}
			}
		}
		
		return canPlayTypes;
	}
});



// WEBPACK FOOTER //
// ./src/controllers/modal/videoTutorial.controller.js